//ELECTRICAL
export const GET_DEVICEDATA_FILE = 'GET_DEVICEDATA_FILE';
export const ERROR_DEVICEDATA = 'ERROR_DEVICEDATA';
export const GET_DEVICEDATA_ANALYSIS = 'GET_DEVICEDATA_ANALYSIS';
export const ERROR_DEVICEDATA_ANALYSIS = 'ERROR_DEVICEDATA_ANALYSIS';


//CLEAR ELECTRICAL
export const CLEAR_DEVICEDATA = 'CLEAR_DEVICEDATA';